    import { CLUB_PURCHASE_RECEIPT_STATUS } from "@clubInventory/constants/dataEnums";

// 功能：進貨單狀態對應顏色（Chip）
export const statusColorByValue = {
	[CLUB_PURCHASE_RECEIPT_STATUS.WAITTINSPECTION]: "warning",
	[CLUB_PURCHASE_RECEIPT_STATUS.PARTIALINSPECTION]: "info",
	[CLUB_PURCHASE_RECEIPT_STATUS.COMPLETED]: "success",
	[CLUB_PURCHASE_RECEIPT_STATUS.CANCELLED]: "gray",
	[CLUB_PURCHASE_RECEIPT_STATUS.EXCEPTIONCLOSED]: "error",
};
